"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compass = void 0;
const axios_1 = __importDefault(require("axios"));
const path_to_regexp_1 = require("path-to-regexp");
const api = __importStar(require("../api"));
let instance;
class CompassClient {
    constructor() {
        this.httpClient = axios_1.default.create();
        this.defaultLanguage = 'en-US';
        this.defaultCurrency = 'USD';
        if (!instance)
            instance = this;
        return instance;
    }
    get interceptors() {
        return this.httpClient.interceptors;
    }
    set interceptors(value) {
        Object.assign(this.httpClient.interceptors, value);
    }
    httpConfig(config) {
        Object.assign(this.httpClient.defaults, config);
    }
    setLanguage(lang) {
        this.defaultLanguage = lang;
    }
    async do(namespace, action, options) {
        if (!api[namespace] || !api[namespace][action]) {
            throw new Error(`Invalid namespace or action name: ${namespace}.${action}`);
        }
        const currentAction = api[namespace][action];
        const path = currentAction.path;
        const method = currentAction.method || 'get';
        const toPath = path_to_regexp_1.compile(path);
        const query = options.query || {};
        query.limit = options.limit;
        query.page = options.page;
        query.filter = options.filter;
        query.populate = options.populate;
        query.select = options.select;
        query.sort = options.sort;
        query.lang = options.lang || this.defaultLanguage;
        if (options.currency) {
            query.currency = options.currency || this.defaultCurrency;
        }
        return this.httpClient.request({
            url: toPath(options.params),
            method: method,
            params: query,
            data: options.data,
            headers: options.headers,
            onUploadProgress: options.onUploadProgress,
            onDownloadProgress: options.onDownloadProgress,
        });
    }
}
exports.compass = new CompassClient();
//# sourceMappingURL=client.js.map